import React from 'react';

const AuthLayout = ({ children }) => (
  <div className="auth-layout">
    {children}
  </div>
);

export default AuthLayout;
